<div>
  <!-- <h1 class="pt-2"
    *ngIf="dialogData.highlight">{{'COMMON.LABEL.HIGHLIGHT_NEWS' | translate}}</h1>
  <h1 class="pt-2"
    *ngIf="!dialogData.highlight">{{'COMMON.LABEL.NEWS' | translate}}</h1> -->

  <div class="w-100 text-center border-bottom">
    <h2 class="mb-1">
      {{news.title}}
    </h2>
  </div>
  <div [innerHTML]="news.body | bitfSafeHtml"
    class="p-2 pt-3">
  </div>

  <div class="d-flex justify-content-end mt-2">
    <button mat-stroked-button
      tabindex="-1"
      class="ml-3"
      (click)="next()">
      {{ 'COMMON.LABEL.CLOSE' | translate }}
    </button>
  </div>
</div>